import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import MechaInfoTextModalStore from './store';

const styles = require('./index.less');

/**
 *  机兵信息, 驾驶员故事 mecha-info-text-modal
 */
const MechaInfoModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.commonDemoModalRoot)}>
        <Link className={styles.closeBtn} onClick={store.onClickClose} />
        <div className={styles.content}>
          <div className={styles.imgsBox}>
            <img className={styles.mecha_history_image} src={store.mecha_history_image} alt="" />
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(MechaInfoModal, MechaInfoTextModalStore);
